import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { formatPriceToman } from '../../../utils/formatPriceToman';
import {
  BankOutlined,
  RiseOutlined,
  CheckCircleOutlined,
  InboxOutlined,
  WarningOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;

const FinanceKPIs = ({ kpis, loading }) => {
  if (!kpis) return null;

  const currentMonthName = kpis.period?.jalali_month || 'ماه جاری';

  const kpiData = [
    {
      title: 'نقدینگی حاضر',
      subtitle: 'مانده عملیاتی حساب‌ها',
      value: kpis.total_liquid_cash ?? kpis.current_liquid_balance ?? 0,
      icon: <BankOutlined className="text-blue-500 text-2xl" />,
      bg: 'bg-blue-50 dark:bg-blue-900/20'
    },
    {
      title: `کل فروش ماه (${currentMonthName})`,
      subtitle: 'فقط معاملات موفق',
      value: kpis.total_sales_mtd ?? kpis.monthly_sales ?? 0,
      icon: <RiseOutlined className="text-emerald-500 text-2xl" />,
      bg: 'bg-emerald-50 dark:bg-emerald-900/20',
      badgeColor: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30'
    },
    {
      title: `کل وصولی ماه (${currentMonthName})`,
      subtitle: 'واریزی‌های تایید شده',
      value: kpis.total_collection_mtd ?? kpis.monthly_collected ?? 0,
      icon: <CheckCircleOutlined className="text-emerald-500 text-2xl" />,
      bg: 'bg-emerald-50 dark:bg-emerald-900/20'
    },
    {
      title: 'چک‌های نزد صندوق',
      subtitle: 'در انتظار وصول / واگذاری',
      value: kpis.vault_cheques_amount ?? kpis.cheques_in_vault ?? 0,
      icon: <InboxOutlined className="text-amber-500 text-2xl" />,
      bg: 'bg-amber-50 dark:bg-amber-900/20'
    },
    {
      title: 'چک‌های برگشتی',
      subtitle: 'مطالبات معوق',
      value: kpis.bounced_cheques_amount ?? kpis.bounced_cheques ?? 0,
      icon: <WarningOutlined className="text-red-500 text-2xl" />,
      bg: 'bg-red-50 dark:bg-red-900/20'
    }
  ];

  return (
    <Row gutter={[16, 16]} className="mb-6">
      {kpiData.map((item, index) => (
        <Col xs={24} sm={12} md={8} lg={4} key={index} className="flex-1 min-w-[200px]">
          <Card 
            loading={loading}
            bordered={false} 
            className="shadow-sm hover:shadow-md transition-all duration-300 dark:bg-gray-800 rounded-2xl overflow-hidden h-full flex flex-col justify-between"
            bodyStyle={{ padding: '20px', display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}
          >
            <div>
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.bg}`}>
                  {item.icon}
                </div>
                {item.badgeColor && (
                  <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${item.badgeColor}`}>
                    {item.subtitle}
                  </span>
                )}
              </div>
              <div>
                <Text className="text-gray-500 dark:text-gray-400 text-sm font-medium block">{item.title}</Text>
                <Title level={4} className="mt-1 mb-0" style={{ marginTop: '8px' }}>
                  {formatPriceToman(item.value || 0)}
                </Title>
              </div>
            </div>
            {!item.badgeColor && item.subtitle && (
              <div className="mt-3 pt-2 border-t border-gray-100 dark:border-gray-700/50">
                <Text className="text-gray-400 text-xs">{item.subtitle}</Text>
              </div>
            )}
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default FinanceKPIs;
